// pages/ToolsAndFeatures.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as LucideIcons from 'lucide-react';
import '../styles/toolsAndFeatures.css';

function ToolsAndFeatures() {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const response = await axios.get('https://n8n.iniai.cloud/webhook/get-tools', {
          headers: {
            'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
            'Content-Type': 'application/json'
          },
          withCredentials: true
        });

        const sortedTools = response.data.sort((a, b) => a['Tool ID'] - b['Tool ID']);
        setTools(sortedTools);
      } catch (err) {
        console.error('Error fetching tools:', err);
        setError('Failed to load tools');
      } finally {
        setLoading(false);
      }
    };

    fetchTools();
  }, []);

  if (loading) return <div className="loading-state">Loading tools...</div>;
  if (error) return <div className="error-state">{error}</div>;

  return (
    <div className="tools-container">
      <h1>Tools</h1>
      <p className="tools-intro">
        Access our suite of AI-powered tools and features:
      </p>

      <div className="tools-grid">
        {tools.map(tool => {
          if (!tool) return null;

          const status = (tool['Tool Status'] || 'Coming Soon').toLowerCase();
          const features = tool['Tool Features'] 
            ? (Array.isArray(tool['Tool Features']) 
              ? tool['Tool Features'] 
              : tool['Tool Features'].split(',').map(f => f.trim()))
            : [];
          const accessRoles = Array.isArray(tool['Access Roles']) 
            ? tool['Access Roles'] 
            : [tool['Access Roles'] || 'all'];
          
          return (
            <div key={tool['Tool ID']} className={`tool-card ${status}`}>
              <div className="tool-icon">
                {tool['Tool Icon'] && LucideIcons[tool['Tool Icon']] ? 
                  React.createElement(LucideIcons[tool['Tool Icon']], {
                    size: 32,
                    className: "icon-primary"
                  }) 
                  : <LucideIcons.FileText size={32} className="icon-primary" />
                }
              </div>

              <div className="tool-header">
                <h2>
                  {tool['Tool Name']}
                  {status === 'coming soon' && (
                    <span className="status-badge">
                      <LucideIcons.Clock size={14} />
                      Coming Soon
                    </span>
                  )}
                </h2>
              </div>

                                {tool['Tool Category'] && (
                <div className="tool-category">
                  <LucideIcons.Tag size={16} className="icon-secondary" />
                  {tool['Tool Category']}
                </div>
              )}
              
              {tool['Tool Description'] && (
                <p className="tool-description">
                  {tool['Tool Description']}
                </p>
              )}

              {features.length > 0 && (
                <div className="tool-features">
                  <ul>
                    {features.map((feature, index) => (
                      <li key={index}>
                        <span className="feature-tag">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {!accessRoles.includes('all') && (
                <div className="access-roles">
                  <LucideIcons.Lock size={14} className="icon-secondary" />
                  {accessRoles.join(', ')}
                </div>
              )}

              {status === 'active' && (
                <a 
                  href={tool['Tool Link']} 
                  className="tool-link"
                >
                  Access Tool
                  <LucideIcons.ChevronRight size={16} />
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ToolsAndFeatures;